import React, { useState, useEffect }  from 'react';
import axios from 'axios';
import './../styles/Login.css';
import './../styles/GlobalStyles.css';
import * as globals from './../components/GlobalScripts.js';

const Login = () => {
    const [code, setCode] = useState('');
    let path_api = localStorage.getItem('path_api');
    var time_await = 0;
    var interval_ = null;

    useEffect(() => {
        new_send_mail();

        if(!interval_)
            interval_ = window.setInterval(function(){
                let element = document.getElementById('new-mail');

                if(!element) clearInterval(interval_);
                
                if(time_await > 0){
                    time_await--;
        
                    element.innerHTML = `(${time_await}s)`
                }else
                    element.innerHTML = "";
            }, 1000);
    }, []);

    const send_mail = async () => {
        time_await = 60;
        localStorage.removeItem('code_confirm');

        globals.openViewCharge();
        await axios.post(`${path_api}/login_code_send_mail.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin()
        }).then(response => {
            if(response.data.mensaje == "success"){
                globals.createAlert({type: "success", msg_title: "Codigo enviado", msg: "Revisa tu correo", effect: "opacidad 2s, desplazamiento 2s", time_life: 10000});
            }else if(response.data.mensaje){
                if(response.data.mensaje == "No hay una sesion iniciada" || response.data.mensaje == "No se encontro una sesion activa"){
                    globals.createAlert({ type: "error", msg_title: "Error", msg: "Inicia sesion de nuevo", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
                    window.setTimeout(function(){
                        window.location.href = './../login';
                    }, 4000);
                }else{
                    globals.createAlert({type: "error", msg_title: "Error", msg: response.data.mensaje, effect: "opacidad 2s, desplazamiento 2s", time_life: 4000});
                }
            }else{
                globals.createAlert({ type: "error", msg_title: "Error", msg: "Si persiste informa al soporte", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error 'log-send-mail-1'", msg: "Si persiste informa al soporte", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
        globals.closeViewCharge();
    };

    const new_send_mail = () => {
        if(time_await == 0){
            send_mail();
        }else{
            globals.createAlert({type: "error", msg_title: "Error", msg: `Espera ${time_await} segundos para enviar otro`, effect: "opacidad 2s, desplazamiento 2s", time_life: 6000});
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        let inputs = document.querySelector('.card-login').querySelectorAll('input');
        let codigo = inputs[0].value ? inputs[0].value.trim() : '';

        if (!codigo) {
            globals.createAlert({ type: "error", msg_title: "Falta informacion", msg: "Ingresa tu codigo", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            inputs[0].classList.add('requiered-outline');
        } else inputs[0].classList.remove('requiered-outline');

        if (document.querySelector('.card-login').querySelector('.requiered-outline')) {
            return;
        }

        globals.openViewCharge();
        await axios.post(`${path_api}/login_code_validate.php`, {
            code,
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin()
        }).then(response => {
            if(response.data.mensaje == "success"){
                localStorage.setItem('code_confirm', '1');
                localStorage.setItem('user', JSON.stringify(response.data.user));
                globals.createAlert({type: "success", msg_title: "Validado", msg: "Redirigiendo al proceso requerido", effect: "opacidad 2s, desplazamiento 2s", time_life: response.data.seconds_return*1000});
                
                window.setTimeout(function(){
                    window.location.href = response.data.url_return;
                }, response.data.seconds_return*1000);
            }else if(response.data.mensaje){
                globals.createAlert({type: "error", msg_title: "Error", msg: response.data.mensaje, effect: "opacidad 2s, desplazamiento 2s", time_life: 4000});
            }else{
                globals.createAlert({ type: "error", msg_title: "Error", msg: "Si persiste informe al soporte", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Credenciales incorrectas", msg: "El correo no esta registrado", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
        globals.closeViewCharge();
    };

    return (
        <>
            <div className="card-login">
                <div className="group-column">
                    <h3 className='no-margin'>Codigo de verificación</h3>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="group-column">
                        <label className="requiered-input">Codigo</label>
                        <input type="text" name="code" className="input-primary" value={code} onChange={(e) => setCode(e.target.value)} placeholder="Revisa tu email" />
                    </div>

                    <div className="flex-row justify-end gap-20">
                    <span onClick={new_send_mail} style={{textDecoration: "underline", display: "flex", alignItems: "flex-end", cursor: "pointer"}}>Enviar de nuevo <span id="new-mail"></span></span>
                        <button className="button-primary" type="submit">Continuar</button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default Login;